"use strict";
/**
 * FlexableService.ts
 * Real Flexable OAuth 2.0 Integration for Meci.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexableService = void 0;
class FlexableService {
    constructor() {
        this.listeners = new Set();
        if (typeof window !== 'undefined') {
            this.setupOAuthListeners();
        }
    }
    setupOAuthListeners() {
        window.addEventListener('message', (event) => {
            if (event.data?.type === 'MECI_FLEXABLE_CONNECTED') {
                const data = event.data;
                if (data.displayName) {
                    localStorage.setItem('meci_conn_flexable', data.displayName);
                    if (data.email)
                        localStorage.setItem('meci_conn_flexable_email', data.email);
                    if (data.sub)
                        localStorage.setItem('meci_conn_flexable_sub', data.sub);
                    if (data.picture)
                        localStorage.setItem('meci_conn_flexable_avatar', data.picture);
                    if (data.plan)
                        localStorage.setItem('meci_conn_flexable_plan', data.plan);
                    if (data.accessToken)
                        localStorage.setItem('meci_conn_flexable_token', data.accessToken);
                    localStorage.setItem('meci_conn_flexable_show', 'true');
                    this.notify();
                }
            }
        });
    }
    /**
     * Open Flexable OAuth 2.0 login popup
     */
    loginWithFlexable() {
        const authUrl = 'https://meci.teymensel.com/oauth/flexable';
        const width = 600;
        const height = 750;
        const left = Math.max(0, (window.innerWidth - width) / 2 + window.screenX);
        const top = Math.max(0, (window.innerHeight - height) / 2 + window.screenY);
        const popup = window.open(authUrl, 'meci_flexable_auth', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
        if (popup) {
            popup.focus();
        }
        else {
            window.location.href = authUrl;
        }
    }
    isLoggedIn() {
        return !!(localStorage.getItem('meci_conn_flexable') || localStorage.getItem('meci_conn_flexable_sub'));
    }
    getProfile() {
        const displayName = localStorage.getItem('meci_conn_flexable');
        if (!displayName)
            return null;
        return {
            sub: localStorage.getItem('meci_conn_flexable_sub') || '',
            displayName: displayName,
            email: localStorage.getItem('meci_conn_flexable_email') || '',
            picture: localStorage.getItem('meci_conn_flexable_avatar') || '',
            plan: localStorage.getItem('meci_conn_flexable_plan') || 'free',
            apiLimitMax: 100000,
            apiLimitUsed: 0
        };
    }
    isShowOnProfile() {
        return localStorage.getItem('meci_conn_flexable_show') !== 'false';
    }
    setShowOnProfile(val) {
        localStorage.setItem('meci_conn_flexable_show', String(val));
        this.notify();
    }
    disconnect() {
        localStorage.removeItem('meci_conn_flexable');
        localStorage.removeItem('meci_conn_flexable_email');
        localStorage.removeItem('meci_conn_flexable_sub');
        localStorage.removeItem('meci_conn_flexable_avatar');
        localStorage.removeItem('meci_conn_flexable_plan');
        localStorage.removeItem('meci_conn_flexable_token');
        this.notify();
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notify() {
        this.listeners.forEach(l => {
            try {
                l();
            }
            catch (e) {
                console.error(e);
            }
        });
    }
}
exports.flexableService = new FlexableService();
